import React from 'react';

const FieldHelpText = ({ helpText }) => (
      <div className="helpText" style={{width:'100%', marginLeft: '5px' }} >
            <small className="unbolded-text"> <span
                    dangerouslySetInnerHTML={{
                    __html: helpText
                     }}
                      />
              </small>
      </div> 
  )

export default FieldHelpText


// WEBPACK FOOTER //
// ./src/components/common/FieldHelpText.js